// The ad template catalog (M20). TEMPLATES = what the picker shows (the 5 style families); the M14 set is kept
// as CLASSIC_TEMPLATES (hidden) so an ad saved from one still opens; templateById looks in both.
import type { TemplateDef } from './dsl';
import { FAMILY_TEMPLATES } from './families';
import { CLASSIC_TEMPLATES } from './library';

export const TEMPLATES: TemplateDef[] = FAMILY_TEMPLATES;
export { CLASSIC_TEMPLATES };
export const ALL_TEMPLATES: TemplateDef[] = [...FAMILY_TEMPLATES, ...CLASSIC_TEMPLATES];
